export default {
    infection_type_1: 'Primary',
    infection_type_2: 'Secondary',
    infection_type_3: 'Third or greater',
    infection_type_4: 'Any',
};
